module.exports = __webpack_public_path__ + "static/media/foto4.97ccecfe.png";